export default __webpack_public_path__ + "static/media/gallery_08.3c5d512d.jpg";